import { error } from '@angular/compiler/src/util';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Departamento } from 'src/app/models/departamento';
import { DocType } from 'src/app/models/doc-type';
import { Municipio } from 'src/app/models/municipio';
import { PrivateProfile } from 'src/app/models/private-profile';
import { User } from 'src/app/models/user';
import { AlertService } from 'src/app/_services/alert.service';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { UserService } from '../../../_services/user.service';



@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {

  public editForm: FormGroup;
  privateProfile: PrivateProfile;
  publicProfileUser: User;
  sponsorFieldFilled: any;
  isRefered: any;
  sponsorId: string;

  allDepartamentos: Departamento[];
  municipiosPorDepartamento: Municipio[];

  allCities: any[];
  documentUsed = false;
  isValidDocument = true;
  previousDocument = '';
  checkSponsorDisabled = false;

  validSponsor =  true;
  tuGessiSponsorId = 'TuGessiAdminUser';

  citiesCtrl = new FormControl();
  departamentosCtrl = new FormControl();

  filteredCities: Observable<any[]>;
  filteredDepartamentos: Observable<any[]>;

  emailReferente: any;
  sponsorVerified = false;

  documentTypes: DocType[];
  selectedDocumentType: DocType;

  @HostListener('window:beforeunload', ['$event']) unloadNotification($event: any): void {
    if (this.editForm.dirty) {
      $event.returnValue = true;
    }
  }

  constructor(private firebaseAuthService: FirebaseAuthService, private route: ActivatedRoute,
              private fb: FormBuilder, private userService: UserService,
              private alertService: AlertService, public router: Router) { }

  ngOnInit(): void {
    this.privateProfile = this.route.snapshot.data['privateProfile'];
    this.previousDocument = this.privateProfile.document;

    this.verifyFilledSponsor();

    this.departamentosCtrl.setValue(this.privateProfile.department.name);
    this.citiesCtrl.setValue(this.privateProfile.city.name);


    this.firebaseAuthService.getPublicUserByEmail(this.privateProfile.email).subscribe((user) => {
      this.publicProfileUser = user;
    });

    this.editForm = this.createEditForm();

    this.loadAllDepartamentos();
    this.citiesCtrl.disable();

    this.loadDocumentTypes();

  }

  createEditForm(): FormGroup {

    return this.fb.group({
      email: [this.privateProfile.email || '', Validators.required],
      fullName: [this.privateProfile.fullName || '', Validators.required],
      tugessiUserName: [this.privateProfile.displayName || '', Validators.required],
      documentType: [this.privateProfile.documentType || '', Validators.required],
      document: [this.privateProfile.document || ''],
      address: [this.privateProfile.address || ''],
      mobilePhone: [this.privateProfile.mobilePhoneNumber || ''],
      isRefered: [ ],
      emailOffersCheck: [this.privateProfile.emailOffers],
      emailSponsor: [ , Validators.email]
    });
  }

  verifyFilledSponsor(): void{

    if (this.privateProfile.sponsorId.toString() === this.tuGessiSponsorId) {
      this.sponsorFieldFilled = false;

    } else {
      this.sponsorFieldFilled = true ;
    }
  }

  loadAllDepartamentos() {
    this.userService.getDepartamentos().subscribe(departamentos => {
      this.allDepartamentos = departamentos;

      this.filteredDepartamentos = this.departamentosCtrl.valueChanges
        .pipe(
          startWith(''),
          map(departamento => departamento ? this._filterDepartamentos(departamento) : this.allDepartamentos.slice())
        );
    }, error => {
      console.log(error);
    });
  };

  loadDocumentTypes() {
    this.userService.getDocumentTypes().subscribe(documents => {
      this.documentTypes = documents;

    });
  }

  loadMunicipioByDepartamentoName(name: string) {

    this.setDepartamento(name);
    this.resetMunicipio();

    this.userService.getMunicipiosPorDepartamento(name).subscribe(municipios => {
      this.municipiosPorDepartamento = municipios;
      console.log('municipios de: ', name + ' :');

      this.filteredCities = this.citiesCtrl.valueChanges
        .pipe(
          startWith(''),
          map(city => city ? this._filterCities(city) : this.municipiosPorDepartamento.slice())
        );
      this.citiesCtrl.enable();

    }, error => {
      console.log(error);
    });
  }

  resetDepartamento(): void {
    this.departamentosCtrl.reset();
    this.privateProfile.department.code = '';
    this.privateProfile.department.name = '';
    this.resetMunicipio();
  }

  resetMunicipio() {
    this.citiesCtrl.reset();
    this.privateProfile.city.code = '';
    this.privateProfile.city.name = '';
  }

  private _filterCities(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.municipiosPorDepartamento.filter(city => city.municipio.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterDepartamentos(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allDepartamentos.filter(depto => depto.departamento.toLowerCase().indexOf(filterValue) === 0);
  }

  setCiy(city: any): void {
    this.privateProfile.region.name = city.region;
    this.privateProfile.department.code = city.artamento;
    this.privateProfile.department.name = city.departamento;
    this.privateProfile.city.code = city.c_digo_dane_del_municipio;
    this.privateProfile.city.name = city.municipio;
  }

  setDepartamento(departamentoName): void {
    let municipio = this.allDepartamentos.find(departamento => departamento.departamento === departamentoName);

    this.privateProfile.region.name = '';
    this.privateProfile.department.code = municipio.codDepertamento;
    this.privateProfile.department.name = municipio.departamento;
  }

  focusOutDepartamento(event: any): void {
    const inputDepartamento = event.target.value;
    let dept = this.allDepartamentos.find(dept => dept.departamento === inputDepartamento.toString());

    if (!dept) {
      this.resetDepartamento();
    }
  }

  focusOutMunicipio(event: any): void {
    const inputMunicipio = event.target.value;
    let municipio = this.municipiosPorDepartamento.find(mun => mun.municipio === inputMunicipio.toString());

    if (!municipio) {
      this.resetMunicipio();
    }
  }

  setMunicipio(municipioName): void {
    let city: Municipio = this.municipiosPorDepartamento.find(municipio => municipio.municipio === municipioName);

    this.privateProfile.city.code = city.codMunicipio;
    this.privateProfile.city.name = city.municipio;
  }

  submit(): void{

    if (this.editForm.valid &&
      (this.sponsorVerified && this.isRefered || !this.isRefered) &&
      !this.documentUsed && this.isValidDocument ) {

      this.privateProfile.fullName = this.editForm.get('fullName').value;
      this.privateProfile.displayName = this.editForm.get('tugessiUserName').value;
      this.publicProfileUser.displayName = this.privateProfile.displayName;
      this.privateProfile.documentType = this.editForm.get('documentType').value;
      this.privateProfile.document = this.editForm.get('document').value;
      this.privateProfile.address = this.editForm.get('address').value;
      this.privateProfile.mobilePhoneNumber = this.editForm.get('mobilePhone').value;
      this.privateProfile.emailOffers = this.editForm.get('emailOffersCheck').value;


      if ( !this.sponsorFieldFilled && this.isRefered) {
        this.privateProfile.sponsorId = this.sponsorId;
      }
      // else {
      //   this.privateProfile.sponsorId = this.tuGessiSponsorId;
      // }

      this.firebaseAuthService.displayNameObs = new BehaviorSubject<string>(this.publicProfileUser.displayName);
    }



    this.firebaseAuthService.updatePublicProfileUser(this.publicProfileUser.id, {displayName: this.publicProfileUser.displayName})
            .subscribe(() => {
              console.log(this.privateProfile);

              this.firebaseAuthService.updatePrivateProfileUser(this.publicProfileUser.id, this.privateProfile)
              .subscribe(() => {
                this.alertService.openAlertDialog('Actualizado correctamente', false, false);
                this.alertService.alertDialgoRef.afterClosed().subscribe(result => {
                  console.log(result);
                  this.router.navigate(['']);
                });
              });
            });
  }

  OnChekboxChange(e): void {
    this.isRefered = this.editForm.get('isRefered').value;
    if ( this.isRefered ) {
      this.validSponsor = false;
    }
   }

   viewSponsor(): void{
     this.firebaseAuthService.getSponsorById(this.privateProfile.sponsorId)
        .subscribe(sponsor => {
          this.alertService.openAlertDialog(`<b>Tu patrocinador es</b>: <br> ${sponsor.displayName} <br>
           <b> Puedes escribirle a</b>:<br> ${sponsor.email}`, false, false);

    });

  }

  async verifySponsor(email: string): Promise<void> {
    this.firebaseAuthService.verifySponsor(email)
    .subscribe(answ => {
      console.log(answ);
      this.sponsorId = answ.toString();
      this.sponsorVerified = true;
      this.checkSponsorDisabled = false;
      this.alertService.openAlertDialog('¡Patrocinador confirmado!', false, false);
    }, error => {
      this.sponsorVerified = false;
      this.checkSponsorDisabled = true;
      if (error.error.message === 'Sponsor not found') {
        this.alertService.openAlertDialog('Por favor verifica el correo de la persona que te refirió', true, false);
      } else if (error.error.message === 'Not email confirmed') {
        this.alertService.openAlertDialog('El usuario no ha confirmado su cuenta, ¡por favor avísale!', true, false);
      } else {
        this.alertService.openAlertDialog('Error desconocido al verificar el correo del referido', true, false);
      }
    });
  }

  async verifyDocumentExists(): Promise<void>{
    this.firebaseAuthService.veryfyDocumentAvailable(this.editForm.value.document)
      .subscribe(anws =>
        {
          if (anws.valid) {
            this.documentUsed = false;
            this.isValidDocument = true;
          } else {
            if (this.previousDocument === this.editForm.value.document){
              this.documentUsed = false;
              this.isValidDocument = true;
            } else {
              this.documentUsed = true;
              this.isValidDocument = false;
            }
          }
        });
  }

  disableSubmmit(): void{
    this.isValidDocument = false;
  }

  checkSponsorDisabledSubmit(): void {
    this.checkSponsorDisabled = true;
  }

  documentTypeSelection(docSelected) {

    this.selectedDocumentType = this.documentTypes.find(doc => doc.name == docSelected);

  }



}
